<script>
export default {
    name: "PatientsAccounts",

    data() {

        return {
            search: ``,
            patients: [],
        };
    },

    mounted() {

        this.fetchQueue()
    },

    methods: {

        fetchQueue() {
            let url = `Pharmacy/GetOutPatientPharmacyQueue`;
                url += this.search ? `?SearchText=${this.search}` : ``;
            this.$root.loading = true;
            return this.$http.get(url).then(response => {
                this.patients = response.data;
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                <h5 class="font-semibold">Outpatient pharmacy queue</h5>
              </template>
              <template v-slot:card-body>
                  <div class="w-full overflow-auto">
                        <div class="w-full flex flex-wrap">
                            <div class="md:w-1/4 sm:w-1/2 p-tiny">
                                <input type="text" 
                                    @keydown.enter="fetchQueue" v-model.trim="search"
                                    class="input-sm input-control text-sm" placeholder="Search">
                            </div>
                            <div class="w-1/4 p-tiny">
                                <button class="btn-sm btn-primary text-xs" @click.prevent="fetchQueue"><i class="fa fa-search"></i> Filter</button>
                            </div>
                        </div>
                        <table class="w-full table table-hover">
                            <thead class="bg-indigo-400 text-sm">
                                <tr class="flex text-white w-full">
                                    <th class="p-tiny w-1/6">Patient</th>
                                    <th class="p-tiny flex-1">Date</th>
                                    <th class="p-tiny flex-1">IP NO</th>
                                    <th class="p-tiny flex-1">OP NO</th>
                                    <th class="p-tiny flex-1">Visits</th>
                                    <th class="p-tiny flex-1">Status</th>
                                    <th class="p-tiny flex-1">Payment</th>
                                    <th class="p-tiny w-1/6">PMode</th>
                                    <th class="p-tiny flex-1">Dispense</th>
                                </tr>
                            </thead>
                            <tbody class="text-xs bg-gray-100 font-semibold flex flex-col items-center overflow-auto w-full" style="height: 67vh;">
                                <tr class="flex w-full" v-for="(pat,idx) in patients" :key="idx">
                                    <td class="p-tiny w-1/6">
                                        <h5 class="text-sm text-gray-900">{{ pat.names }}</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">
                                            MRN: {{ pat.patienT_ID }}</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">
                                            DOB: {{ pat.dob | dateFormat }}</h5>
                                    </td>
                                    <td class="p-tiny flex-1">{{ pat.date | dateFormat }}</td>
                                    <td class="p-tiny flex-1">{{ pat.ipfileno || `-` }}</td>
                                    <td class="p-tiny flex-1">{{ pat.opfileno || `-` }}</td>
                                    <td class="p-tiny flex-1">{{ pat.visitCount }}</td>
                                    <td class="p-tiny flex-1">{{ pat.patientstatus }}</td>
                                    <td class="p-tiny flex-1">{{ pat.payment }}</td>
                                    <td class="p-tiny w-1/6 break-words">{{ pat.pmode }}</td>
                                    <td class="p-tiny flex-1">
                                        <router-link 
                                            class="btn-sm text-xs btn-primary rounded" 
                                            :to="{ name: `pharmacy.dispense.create`, params: { patientID: pat.patienT_ID, visitNO: pat.visitNo,}}">
                                                 <i class="fa fa-pills"></i>
                                        </router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                  </div>
              </template>
            </tail-card>
        </template>
        
    </tail-base-layout>
</template>